import { render, staticRenderFns } from "./ImageUploadGallery.vue?vue&type=template&id=1f65faa8&scoped=true"
import script from "./ImageUploadGallery.vue?vue&type=script&lang=js"
export * from "./ImageUploadGallery.vue?vue&type=script&lang=js"
import style0 from "./ImageUploadGallery.vue?vue&type=style&index=0&id=1f65faa8&prod&scoped=true&lang=css"
import style1 from "./ImageUploadGallery.vue?vue&type=style&index=1&id=1f65faa8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f65faa8",
  null
  
)

export default component.exports